<template>
  <div v-if="activeTab === 'terms'" class="card card-outline-primary rounded-3 shadow">
    <div class="card-body p-0 px-4 py-3">
      <div class="d-flex justify-content-between align-items-center">
        <ul class="card-progress-tracker fw-bold text-center mb-0">
          <li :class="termsStatus.class">
            {{ termsStatus.text }}
          </li>
        </ul>
      </div>
      <transition name="slide-fade">
        <div v-if="workflowData && workflowData.workflow_completed && workflowData.workflow_completed.consent_provided" class="terms-container">
          <hr class="fw-light" />
          <div class="row">
            <div class="col-12">
              <div class="terms-header p-3 mb-3 border rounded-3">
                <div class="d-flex align-items-center">
                  <div class="terms-icon me-3">
                    <i class="bi bi-file-earmark-text-fill text-primary fs-4"></i>
                  </div>
                  <div>
                    <h6 class="fw-bold mb-1">Terms and Conditions</h6>
                    <small class="text-muted">Uploaded terms and conditions document</small>
                  </div>
                </div>
              </div>
              <div class="terms-iframe-container border rounded-3 overflow-hidden">
                <iframe :src="workflowData.terms_and_conditions" width="100%" height="500px" frameborder="0"></iframe>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="text-center py-5">
          <i class="bi bi-file-earmark-x text-muted fs-1 mb-3"></i>
          <p class="text-muted">{{ termsStatus.text }}</p>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TermsTab',
  props: {
    activeTab: {
      type: String,
      default: 'terms'
    },
    workflowData: {
      type: Object,
      default: null
    },
    termsStatus: {
      type: Object,
      default: () => ({ class: 'in-completed', text: 'Terms and Conditions Not Available' })
    }
  }
}
</script>

<style scoped>
.terms-header {
  background: #f8f9fa;
}

.terms-icon {
  background: rgba(0, 123, 255, 0.1);
  border-radius: 8px;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.terms-iframe-container iframe {
  border: none;
}
</style>
